import { RouteConfig } from 'vue-router'
import i18n from '@/i18n'

const routes: Array<RouteConfig> = [
    {
        path: '/accounts',
        name: 'accounts',
        meta: { title: i18n.t('integration', { brand: process.env.VUE_APP_BRAND }) },
        component: () => import('@/modules/settings/components/Accounts.vue')
    },
    {
        path: '/accounts/:accId',
        name: 'account_settings',
        meta: { title: i18n.t('integration', { brand: process.env.VUE_APP_BRAND }) },
        component: () => import('@/modules/settings/components/AccountSettings.vue'),
        props: true
    }
]

export default routes
